import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const CouponsProvider = (props) => {
  const api = new API();
  const [couponsLoader, setCouponsLoader] = useState({
    plandropdown: false
  });
  const [tableFilter, setTableFilter] = useState({
    name: '',
    page: 1,
    limit: 20
  })
  const [singleListLoader,setSingleListLoader] = useState(false);
  const [listLoader,setListLoader] = useState(false);
  const [addLoader, setAddLoader] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [plandropdown, setPlansDropdown] = useState([]);
  const [studentDropdown, setStudentDropdown] = useState([]);
  const [handleSearch, setHandleSearch] = useState("");
  const [couponsError, setCouponsError] = useState(null);
  const [couponsList, setCouponsList] = useState([]);
  const [viewSingleCoupon, setViewSingleCoupon] = useState({});
  const [singleCouponId, setSingleCouponId] = useState(null);
  const [onActiveCoupon, setOnActiveCoupon] = useState(false);
  const [couponDeleteLoader, setCouponDeleteLoader] = useState(false);
  const [couponForm, setCouponForm] = useState({
    plan_name: [],
    coupon_name: "",
    coupon_code: "",
    valid_from: "",
    valid_till: "",
    count_limit: 0,
    count_limit_user: null,
    applicable_for: 0,
    student_id: [],
    discount_type: "all",
    flat_discount: {
      discount: null,
      type:'fixed',
    },
    custom_discount: []
  });
  const [couponAddForm, setCouponAddForm] = useState({
    plan_name: [],
    coupon_name: "",
    coupon_code: "",
    valid_from: "",
    valid_till: "",
    count_limit: 0,
    count_limit_user: null,
    applicable_for: 0,
    student_id: [],
    discount_type: "all",
    flat_discount: {
      discount: null,
      type:'fixed',
    },
    custom_discount: []
  });
  const [couponEditForm, setCouponEditForm] = useState({
    plan_name: [],
    coupon_name: "",
    coupon_code: "",
    valid_from: "",
    valid_till: "",
    count_limit: 0,
    count_limit_user: null,
    applicable_for: 0,
    student_id: [],
    discount_type: "all",
    flat_discount: {
      discount: null,
      type:'fixed',
    },
    custom_discount: []
  });
  const [couponTrackOne, setCouponTrackOne] = useState({});
  const [couponTrackOneLoader, setCouponTrackOneLoader] = useState(false);
  const [couponTrackTwo, setCouponTrackTwo] = useState({});
  const [couponTrackTwoLoader, setCouponTrackTwoLoader] = useState(false);


  const fetchCouponTrackOne = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setCouponTrackOneLoader(true)
    await api.getAll("coupons/coupon_track_code_one", {
      id:id
    }, (err, res) => {    
      if (res?.data?.status === 200) {
        setCouponTrackOne(res?.data?.data)
      } else {
        setCouponTrackOne({}) 
      }
      setCouponTrackOneLoader(false)
    })
  }
  const fetchCouponTrackTwo = async (code,duration_id) => {
    const data = {};
    data.code = code;
    if(duration_id!="null") {
      data.duration_id = duration_id;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setCouponTrackTwoLoader(true)
    await api.getAll("coupons/coupon_track_code_two", data, (err, res) => {    
      if (res?.data?.status === 200) {
        setCouponTrackTwo(res?.data?.data)
      } else {
        setCouponTrackTwo({})
      }
      setCouponTrackTwoLoader(false)
    })
  }

  const fetPlansMasterDropdown = async () => {
    setCouponsLoader({
      ...couponsLoader,
      plandropdown: true
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.getAll("coupons/plandropdown", {}, (err, res) => {    
      if (res?.data?.status === 200) {
        setPlansDropdown(res?.data?.data)
      } else {
        setPlansDropdown([])
      }
      setCouponsLoader({
        ...couponsLoader,
        plandropdown: false
      });
    }))
  }
  const deleteCoupon = async (id,fetchCouponsList=null) => {
    setCouponDeleteLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.remove("coupons/deletecoupons", id, (err, res) => {    
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        fetchCouponsList && fetchCouponsList();
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setCouponDeleteLoader(false);
    }))
  }

  const fetchStudentDropdown = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.getAll("coupons/studentdropdown", {}, (err, res) => {    
      if (res?.data?.status === 200) {
        setStudentDropdown(res?.data?.data)
      } else {
        setStudentDropdown([])
      }
    }))
  }

  const fetPlansMasterDropdownDetails = async (id=[]) => {
    if(id.length===0) {
      setCouponAddForm({
        ...couponAddForm,
        custom_discount: [],
        plan_name: [],
      })
    };
    if(!id) return;
    
    setCouponsLoader({
      ...couponsLoader,
      plandropdown: true
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.create("coupons/plandropdowndetails", {id:id}, (err, res) => {    
      if (res?.data?.status === 200) {
        setCouponForm({
          ...couponForm,
          custom_discount: res?.data?.data
        })
      } else {
        setCouponForm({  
          ...couponForm,
          custom_discount: []
        })
      }
      setCouponsLoader({
        ...couponsLoader,
        plandropdown: false
      });
    }))
  }

  const allCoupons = async (data) => {
    setAddLoader(true);
    const result = localStorage.getItem("rxdx_admin_login") === "true" && await api.create("coupons", data, (err, res) => {    
      if(err) {
        Widget.showMessage("error", err?.response?.data?.message);
      }
      setAddLoader(false);
    });
    return result;
  }

  const fetchCouponsList = async () => {
    setListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.getAll("coupons", {...tableFilter}, (err, res) => {    
      if (res?.data?.status === 200) {
        setCouponsList(res?.data?.data)
      } else {
        setCouponsList([])
      }
      setListLoader(false);
    }))
  }

  const getSingleCoupon = async (id) => {
    setSingleListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.getSingle("coupons/single", id, (err, res) => {    
      if (res?.data?.status === 200) {
        fetPlansMasterDropdownDetails(res?.data?.data?.plan_name?.map(item => item?._id))
        setSingleCouponId(res?.data?.data?._id)
        setViewSingleCoupon(res?.data?.data)
        setCouponEditForm((prev)=>{
          return {
            ...prev,
            ...res?.data?.data,
            plan_name: res?.data?.data?.plan_name?.map(item => item?._id),
            student_id: res?.data?.data?.student_id?.map(item => item?.value),
          }
        })
        setOnActiveCoupon(res?.data?.data?.status===1?true:false);
      } else {
        setViewSingleCoupon({})
        setCouponEditForm({})
      }
      setSingleListLoader(false);
    }))
  }

  const editCoupons = async (data,id) => {
    setEditLoader(true);
    const result =
      localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("coupons",id, data, (err, res) => {
        if (err) {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setEditLoader(false);
      }));
    return result;
  };

   const statusUpdateCoupon = async (status = null, id = null) => {
     if (!id) {
       Widget.showMessage("error", "ID is required");
       return;
     }
     if (status === null || status === "" || status === undefined) {
       Widget.showMessage("error", "Status is required");
       return;
     }
     const res =
       localStorage.getItem("rxdx_admin_login") &&
       api.update("coupons/status", id, { status: status }, (err, res) => {
         if (res) {
           setViewSingleCoupon((prev) => ({
             ...prev,
             status: res?.data?.data?.status,
           }));
           Widget.showMessage("success", res?.data?.message);
           fetchCouponsList();
         } else {
           Widget.showMessage("error", err?.response?.data?.message);
         }
       });
     return res;
   };

   return (
     <Context.Provider
       value={{
         ...props,
         fetPlansMasterDropdown,
         couponsLoader,
         setCouponsLoader,
         fetchStudentDropdown,
         couponForm,
         setCouponForm,
         fetPlansMasterDropdownDetails,
         couponAddForm,
         setCouponAddForm,
         plandropdown,
         setPlansDropdown,
         studentDropdown,
         setStudentDropdown,
         handleSearch,
         setHandleSearch,
         couponsError,
         setCouponsError,
         allCoupons,
         couponsList,
         setCouponsList,
         fetchCouponsList,
         listLoader,
         setListLoader,
         tableFilter,
         setTableFilter,
         singleListLoader,
         setSingleListLoader,
         getSingleCoupon,
         couponEditForm,
         setCouponEditForm,
         editLoader,
         setEditLoader,
         editCoupons,
         singleCouponId,
         setSingleCouponId,
         viewSingleCoupon,
         setViewSingleCoupon,
         statusUpdateCoupon,
         onActiveCoupon,
         setOnActiveCoupon,
         deleteCoupon,
         couponDeleteLoader,
         setCouponDeleteLoader,
         //
         couponTrackOne, setCouponTrackOne,
         couponTrackOneLoader, setCouponTrackOneLoader,
         couponTrackTwo, setCouponTrackTwo,
         couponTrackTwoLoader, setCouponTrackTwoLoader,
         fetchCouponTrackOne, fetchCouponTrackTwo,
       }}
     >
       {props.children}
     </Context.Provider>
   ); 
};

export default CouponsProvider;